import { MENUS } from '../apollo/menu/menus.graphql'
import { useLazyQuery } from 'react-apollo'
import { useRestaurant } from '../components/RestaurantProvider/RestaurantProvider'
import { useFulfillment } from '../components/FulfillmentProvider/FulfillmentProvider'
import { useOutpostRestaurant } from '../components/OutpostProvider/OutpostProvider'
import { useEffect } from 'react'
import { dataByTypename } from '../utils/apollo-helpers'

/**
 *
 * @param {import('react-apollo').QueryHookOptions} options
 */
export const useMenus = (options = {}) => {
  const { fulfillmentTime, loading: fulfillmentLoading } = useFulfillment()
  const { outpostDeliveryDateTime, outpostLoading } = useOutpostRestaurant()
  const { shortUrl } = useRestaurant()
  const dateTime = outpostDeliveryDateTime || fulfillmentTime || undefined
  const loading = (fulfillmentLoading || outpostLoading)
  const [ getMenus, menusResponse ] = useLazyQuery(MENUS, options)

  useEffect(() => {
    if (!loading && shortUrl && !options.skip) {
      getMenus({ variables: { input: { shortUrl, dateTime } } })
    }
  }, [getMenus, loading, shortUrl, options.skip, dateTime])

  const { loading: queryLoading, error, data } = menusResponse

  if (!queryLoading && !error && data) {
    const { MenusResponse, GeneralError } = dataByTypename(data.menusV3)

    if (MenusResponse) {
      const { menus } = MenusResponse
      return {
        menus,
        ...menusResponse
      }
    }

    if (GeneralError) {
      return {
        ...menusResponse,
        error: GeneralError
      }
    }
  }

  if (!shortUrl) return { error: new Error('No Short URL Provided') }
  return menusResponse.called ? menusResponse : { loading: true }
}
